import { usePasswordCheck } from '../hooks/usePasswordCheck'

export function PasswordCheck({ children }: { children: React.ReactNode }) {
  const { isChecking } = usePasswordCheck()

  // Don't show loading for every route change
  // The hook handles the redirect, we just pass through
  return <>{children}</>
}